(function($) {
    var __ = {
        body: $('body'),
        window: $(window),
        // Scene Controller
        controller: window._animations.base.controller,
        global: window._animations.base,

        calloutParallax: function() {
            // Get all the posts on the page
            var callouts = $('.j-post');

            // loop through the posts
            callouts.each(function() {
                
                // Set the current post
                // Grab a random (50px increments between 100 and 250) number for offset
                // Setup an 'In' tween
                var _callouts = $(this);
                _callouts.find('.j-parallax--callouts--single').each(function() {
                    var _this = $(this);


                    inTweens.push(TweenMax.fromTo(_this, 1, { opacity: 0, top: topShift }, { opacity: 2, top: 0, ease: Linear.easeNone }));
                    outTweens.push(TweenMax.fromTo(_this, 1, { opacity: 3, top: 0 }, { opacity: 0, top: -topShift, ease: Linear.easeNone }));
                    index++;
                    if (index > 4) {
                        index = 1;
                    }
                });

                // build tween
                var inTweenTimeline = new TimelineLite().add(inTweens);
                var outTweenTimeline = new TimelineLite().add(outTweens);

                var height = __.window.height();
                // build scene
                new ScrollMagic.Scene({ triggerElement: _callouts.get(0), duration: (height / 2) - 50, offset: 99, triggerHook: 1 })
                    .setTween(inTweenTimeline)
                    .addTo(__.controller);
                new ScrollMagic.Scene({ triggerElement: _callouts.get(0), duration: 250, offset: -150, triggerHook: 0 })
                    .setTween(outTweenTimeline)
                    .addTo(__.controller);
            });
        },

        // Function to call to setup functionality
        setup: function() {
            window._animations.base.setup(); 
        }
    };
    // Attach Toolbox to window //
    if (typeof window._animations === "undefined") {
        window._animations = {};
    }
    window._animations.global = __;
})(jQuery); // Fully reference jQuery after this point.